import { X } from 'lucide-react';
import { type ReactElement, useState } from 'react';
import { InView } from 'react-intersection-observer';

import { Button } from 'src/components/ui/button';
import { Card } from 'src/components/ui/card';
import { Skeleton } from 'src/components/ui/skeleton';
import { cn } from 'src/lib/utils';

export function ConfigurationReferencesSkeleton(): ReactElement {
  const [topShadow, setTopShadow] = useState(true);
  const [bottomShadow, setBottomShadow] = useState(true);
  const [scrollRoot, setScrollRoot] = useState<HTMLDivElement | null>(null);

  return (
    <>
      <span className='absolute top-2 right-1 flex items-center gap-1 font-medium text-layout-foreground-secondary text-sm'>
        <Skeleton className='mt-1 h-4 w-10' />
      </span>
      <Card className='relative flex flex-1 flex-col gap-2 overflow-hidden'>
        <div
          className={cn(
            'flex flex-1 flex-col gap-2 overflow-y-auto pr-4 pb-2 pl-6',
            topShadow && !bottomShadow && 'mask-fade-top',
            bottomShadow && !topShadow && 'mask-fade-bottom',
            topShadow && bottomShadow && 'mask-fade',
          )}
          ref={setScrollRoot}
        >
          <InView
            aria-hidden='true'
            as='div'
            className='h-px shrink-0'
            onChange={(inView) => setTopShadow(!inView)}
            root={scrollRoot}
          />
          {Array.from({ length: 17 }).map((_, index) => (
            <div
              className='flex flex-row items-center justify-between gap-2'
              key={index}
            >
              <div className='flex flex-row items-center justify-between gap-2'>
                <Skeleton className='h-4 w-10' />
                <Skeleton className='h-4 w-80' />
              </div>
              <div className='flex flex-row items-center justify-between gap-4'>
                <Button disabled size='icon' variant='ghost'>
                  <X className='h-4 w-4' />
                </Button>
              </div>
            </div>
          ))}
          <InView
            aria-hidden='true'
            as='div'
            className='h-px shrink-0'
            onChange={(inView) => setBottomShadow(!inView)}
            root={scrollRoot}
          />
        </div>
      </Card>
    </>
  );
}
